const baseUrlEnum = {
  development: "https://fotor-website-upload-test.s3-us-west-2.amazonaws.com",
  testStaging: "https://fotor-website-upload-test.s3-us-west-2.amazonaws.com",
  prodStaging: "https://fotor-website-upload-prod.s3-us-west-2.amazonaws.com"
};

const BASE_URL = baseUrlEnum[process.env.SERVER_ENV] || baseUrlEnum["development"];

module.exports = {
  "1": BASE_URL + "/images/background/",
  "3": BASE_URL + "/images/gallery/",
  "4": BASE_URL + "/images/comparison/",
  "5": BASE_URL + "/images/side/",
  "6": BASE_URL + "/images/feature-card/",
  "7": BASE_URL + "/images/avatar/",
  "8": BASE_URL + "/images/share/",
  "9": BASE_URL + "/images/partners/"
};
